<div class="input-group">
    <input type="text" class="form-control" id="{{id()}}" [value]="inputValue()" readonly>
    <button class="btn btn-outline-secondary" type="button" id="{{id()}}-btn" (click)="copyToClipboard()"
        ><i class="bi bi-copy"></i></button>
</div>
